import { Component, Injector } from '@angular/core';
import { BaseModalComponent } from '../base-modal/base-modal.component';
import { FormLoading } from '../../forms/base-form/base-form.component';
import { ObjectService } from 'src/app/services/object.service';
import { ModelFactory } from 'src/app/models/model-factory';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-add-object-modal',
  templateUrl: './add-object-modal.component.html',
  styleUrls: ['./add-object-modal.component.scss'],
})
export class AddObjectModalComponent extends BaseModalComponent {
  constructor(injector: Injector, private authService: AuthService, private objectService: ObjectService) {
    super(injector);
  }

  public async handleSubmit({ values, formLoading }: { values: any; formLoading: FormLoading }) {
    try {
      this.startLoading();
      formLoading.start();

      const object = await this.authService.auth(values);
      this.objectService.addObject(object);

      formLoading.stop();
      this.stopLoading();
      this.close(object);
    } catch (err) {
      formLoading.stop();
      this.stopLoading();
    }
  }
}
